import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useThemeMode } from '../../../../_metronic/partials'

const ScenarioDataCardSkeleton = () => {
    const { mode } = useThemeMode()
    return (
        <div className='bg-white p-4 scenario-card-width w-md-auto w-100 mb-4 mb-md-auto rounded'>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <Skeleton
                    width={200}
                    height={30}
                    baseColor="var(--kt-skeleton-bg-color)"
                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                />
                <div className='d-flex align-items-center'>
                    <div className='position-relative align-self-center'>
                    </div>
                </div>
            </div>
            <div className='d-flex mb-4'>
                <div className='d-flex flex-column justify-content-around w-100 gap-4'>
                    <div className='d-flex flex-column gap-2'>
                        <Skeleton
                            width={'90%'}
                            height={44}
                            baseColor="var(--kt-skeleton-bg-color)"
                            highlightColor="var(--kt-skeleton-highlight-bg-color)"
                        />
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        <Skeleton
                            width={'90%'}
                            height={44}
                            baseColor="var(--kt-skeleton-bg-color)"
                            highlightColor="var(--kt-skeleton-highlight-bg-color)"
                        />
                    </div>
                </div>
                <div className='d-flex flex-column justify-content-around w-100 gap-4'>
                    <div className='d-flex flex-column gap-2'>
                        <Skeleton
                            width={'90%'}
                            height={44}
                            baseColor="var(--kt-skeleton-bg-color)"
                            highlightColor="var(--kt-skeleton-highlight-bg-color)"
                        />
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        <Skeleton
                            width={'90%'}
                            height={44}
                            baseColor="var(--kt-skeleton-bg-color)"
                            highlightColor="var(--kt-skeleton-highlight-bg-color)"
                        />
                    </div>
                </div>
            </div>
            <div className='d-flex flex-column gap-2'>
                <Skeleton
                    width={'50%'}
                    height={44}
                    baseColor="var(--kt-skeleton-bg-color)"
                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                    className='mb-2'
                />
            </div>
            <div className='my-2' style={{ border: mode === 'dark' ? '#565674 1px solid' : '#F4F4F4 1px solid' }}></div>
            <div>
                <Skeleton
                    width={'100%'}
                    height={40}
                    baseColor="var(--kt-skeleton-bg-color)"
                    highlightColor="var(--kt-skeleton-highlight-bg-color)"
                />
            </div>
        </div>
    )
}

export default ScenarioDataCardSkeleton
